module.exports = __webpack_public_path__ + "static/media/Assets-10-Si-Mayaa-03.6a346f32.png";